<ngu-carousel #carousel [inputs]="carouselTile" [dataSource]="items">
  <ngu-tile *nguCarouselDef="let item; let i = index">
    <!-- {{ item | json  }} -->
    <div class="award">
      <app-box *ngIf="type === 'award'" [award]="item" class="homepage"></app-box>
      <app-favorite-box-mini *ngIf="type === 'favorite'" [award]="item"></app-favorite-box-mini>
    </div>
    <!--    <loreal-award-box [award]="item"></loreal-award-box>-->
  </ngu-tile>
  <button *ngIf="items?.length > 1" NguCarouselPrev class="arrow left"
          [ngClass]="{'show': !carousel.isFirst}">
    <svg style="height: 20px; width: 20px;" class="icon" viewBox="0 0 512 512" >                 <use xlink:href="#chevron-left" x="0" y="0" />               </svg>
  </button>
  <button *ngIf="items?.length > 1" NguCarouselNext class="arrow right"
          [ngClass]="{'show': !carousel.isLast}">
          <svg style="height: 20px; width: 20px;" class="icon" viewBox="0 0 512 512" >
            <use xlink:href="#chevron-right" x="0" y="0" />
          </svg>
  </button>
</ngu-carousel>
